import React, { useContext, useEffect, useState } from 'react'
import Aside from '../component/aside'
import Navbar from '../component/navbar'
import { formatSecondsToTime } from '../component/formatSecondsToTime'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import DateObject from 'react-date-object'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import { FormJsonToShamsiDay } from '../component/FormJsonToShamsiDay'
import Loading from '../component/loading'
import RequestQueue from '../api/requestQueue'
import { FormJsonToShamsiTime } from '../component/FormJsonToShamsiTime'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faBolt,
    faCalendarAlt,
    faCheck,
    faChevronLeft,
    faClock,
    faHistory,
    faInfo,
    faList,
    faPlus,
    faTachometerAlt,
    faTimes,
} from '@fortawesome/free-solid-svg-icons'
import { AppContextMenu } from '../App'

function Dashboard(props) {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('dashboard')
    }, [])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (
            RequestQueue.getAuthResult() === null ||
            RequestQueue.getAuthResult() === undefined ||
            Object.keys(RequestQueue.getAuthResult()).length === 0
        ) {
            navigate('/login')
        } else {
            getFurloughMonth()
            getFurlough()
        }
    }, [])
    let navigate = useNavigate()
    const [dataGet, setDataGet] = useState([])
    const [furloughMonthTime, setFurloughMonthTime] = useState('')

    const getFurlough = async () => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/furlough-request/other`,
            },
            resolve: (res) => {
                setLoading(false)
                setDataGet(res.data)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const handlerView = (id) => {
        navigate(`/furloughGetView/${id}`)
    }

    const getFurloughMonth = async () => {
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/furlough-request/current-month/${RequestQueue.getAuthResult()?.user?.id}`,
            },
            resolve: (res) => {
                setFurloughMonthTime(res.data)
            },
            reject: (error) => {
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    function getStatusText(status) {
        switch (status) {
            case 'pending':
                return 'در انتظار'
            case 'confirm':
                return 'تایید شده'
            case 'reject':
                return 'رد شده'
            default:
                return status
        }
    }

    function getStatusBadgeColor(status) {
        switch (status) {
            case 'pending':
                return 'bg-yellow-100 text-yellow-800'
            case 'confirm':
                return 'bg-green-100 text-green-800'
            case 'reject':
                return 'bg-red-100 text-red-800'
            default:
                return 'bg-gray-100 text-gray-800'
        }
    }

    function getStatusColor(status) {
        switch (status) {
            case 'pending':
                return 'bg-yellow-500'
            case 'confirm':
                return 'bg-green-500'
            case 'reject':
                return 'bg-red-500'
            default:
                return 'bg-gray-500'
        }
    }

    function getStatusIcon(status) {
        switch (status) {
            case 'pending':
                return faClock
            case 'confirm':
                return faCheck
            case 'reject':
                return faTimes
            default:
                return faInfo
        }
    }

    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />

                    {/* Main Dashboard Card */}
                    <div className="bg-white rounded-xl shadow-lg  border border-gray-200 mx-4 my-6">
                        {/* Header */}
                        <div className="px-6 py-5 border-b border-gray-200 bg-gradient-to-r from-indigo-600 to-purple-600">
                            <h2 className="text-2xl font-bold text-white">
                                <FontAwesomeIcon
                                    icon={faTachometerAlt}
                                    className="ml-2"
                                />
                                داشبورد مدیریت مرخصی
                            </h2>
                        </div>

                        {/* Stats and Quick Actions */}
                        <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-6">
                            {/* Leave Summary Card */}
                            <div className="bg-red-50 border border-red-100 rounded-lg p-4">
                                <div className="flex items-center justify-between maxLg:flex-col">
                                    <h3 className="text-lg font-medium text-red-800">
                                        <FontAwesomeIcon
                                            icon={faCalendarAlt}
                                            className="ml-2"
                                        />
                                        {RequestQueue.getAuthResult()?.user?.id
                                            ? RequestQueue.getAuthResult()?.user
                                                  ?.full_name
                                            : ''}
                                    </h3>
                                    <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-sm">
                                        این ماه
                                    </span>
                                </div>
                                <div className="mt-4 text-center">
                                    <p className="text-red-800 text-xl font-bold">
                                        مرخصی استفاده شده:
                                    </p>
                                    {furloughMonthTime && (
                                        <div className="mt-2">
                                            <p className="text-red-900">
                                                {
                                                    furloughMonthTime.totalConfirmedFurloughs
                                                }{' '}
                                                مرخصی
                                            </p>
                                            <p className="text-lg text-red-800">
                                                {formatSecondsToTime(
                                                    furloughMonthTime.totalFurloughHours
                                                )}{' '}
                                                ساعت
                                            </p>
                                        </div>
                                    )}
                                    {furloughMonthTime && (
                                        <div className="mt-2">
                                            <p className=" text-xl font-bold text-red-800">
                                                {' '}
                                                مرخصی مانده:
                                            </p>
                                            <p className="text-lg text-red-800">
                                                {formatSecondsToTime(
                                                    furloughMonthTime.monthlyRemainingHours
                                                )}{' '}
                                                ساعت
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Leave Summary Card */}
                            <div className="bg-indigo-50 border border-indigo-100 rounded-lg p-4">
                                <div className="flex items-center justify-between maxLg:flex-col">
                                    <h3 className="text-lg font-medium text-indigo-800">
                                        <FontAwesomeIcon
                                            icon={faCalendarAlt}
                                            className="ml-2"
                                        />
                                        {RequestQueue.getAuthResult()?.user?.id
                                            ? RequestQueue.getAuthResult()?.user
                                                  ?.full_name
                                            : ''}
                                    </h3>
                                    <span className="bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full text-sm">
                                        این سال
                                    </span>
                                </div>
                                <div className="mt-4 text-center">
                                    <p className=" text-xl font-bold text-indigo-800">
                                        مرخصی استفاده شده:
                                    </p>
                                    {furloughMonthTime && (
                                        <div className="mt-2">
                                            <p className="text-lg  text-indigo-900">
                                                {
                                                    furloughMonthTime.totalConfirmedYearlyFurloughs
                                                }{' '}
                                                مرخصی
                                            </p>
                                            <p className="text-lg text-indigo-800">
                                                {formatSecondsToTime(
                                                    furloughMonthTime.yearlyUsedHours
                                                )}{' '}
                                                ساعت
                                            </p>
                                        </div>
                                    )}
                                    {furloughMonthTime && (
                                        <div className="mt-2">
                                            <p className=" text-xl font-bold text-indigo-800">
                                                {' '}
                                                مرخصی مانده:
                                            </p>
                                            <p className="text-lg text-indigo-800">
                                                {formatSecondsToTime(
                                                    furloughMonthTime.yearlyRemainingHours
                                                )}{' '}
                                                ساعت
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Quick Actions */}
                            <div className="bg-blue-50 border border-blue-100 rounded-lg p-4">
                                <h3 className="text-lg font-medium text-blue-800 mb-4">
                                    <FontAwesomeIcon
                                        icon={faBolt}
                                        className="ml-2"
                                    />
                                    اقدامات سریع
                                </h3>
                                <div className="space-y-3">
                                    <button
                                        className="w-full px-4 py-3 rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all flex items-center justify-center"
                                        onClick={() => navigate('/furloughAdd')}
                                    >
                                        <FontAwesomeIcon
                                            icon={faPlus}
                                            className="ml-2"
                                        />
                                        درخواست مرخصی جدید
                                    </button>
                                    <button
                                        className="w-full px-4 py-3 rounded-xl text-indigo-700 bg-white border border-indigo-300 hover:bg-indigo-50 transition-colors flex items-center justify-center"
                                        onClick={() => navigate('/furlough')}
                                    >
                                        <FontAwesomeIcon
                                            icon={faList}
                                            className="ml-2"
                                        />
                                        مشاهده مرخصی های من
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Recent Leave Requests Table */}
                        <div className="px-6 pb-6">
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="text-lg font-semibold text-gray-800">
                                    <FontAwesomeIcon
                                        icon={faHistory}
                                        className="ml-2"
                                    />
                                    آخرین درخواست‌های در حال انتظار دیگران
                                </h3>
                                <button
                                    onClick={() => navigate('/furloughGet')}
                                    className="text-indigo-600 hover:text-indigo-800 text-sm flex items-center"
                                >
                                    مشاهده همه
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-1"
                                    />
                                </button>
                            </div>

                            <div className="overflow-x-auto">
                                <table className="w-full border-collapse">
                                    <thead>
                                        <tr className="bg-gray-50 text-right">
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
                                                نام و نام‌خانوادگی
                                            </th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
                                                نوع مرخصی
                                            </th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
                                                تاریخ مرخصی
                                            </th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
                                                ساعت مرخصی
                                            </th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
                                                تاریخ ثبت
                                            </th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
                                                وضعیت
                                            </th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
                                                عملیات
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {dataGet.map((d) => (
                                            <tr
                                                key={d.id}
                                                className="hover:bg-gray-50"
                                            >
                                                <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                    {d.user.full_name}
                                                </td>
                                                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {d.type_furlough === 'daily'
                                                        ? 'روزانه'
                                                        : 'ساعتی'}
                                                </td>
                                                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {FormJsonToShamsiDay(
                                                        d.start_date
                                                    )}
                                                </td>
                                                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {d.type_furlough ===
                                                    'hourly'
                                                        ? `${FormJsonToShamsiTime(d.start_date)} تا ${FormJsonToShamsiTime(d.end_date)}`
                                                        : '-'}
                                                </td>
                                                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {FormJsonToShamsiDay(
                                                        d.created_at
                                                    )}
                                                </td>
                                                <td className="px-4 py-4 whitespace-nowrap">
                                                    <span
                                                        className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusBadgeColor(d.status)}`}
                                                    >
                                                        {getStatusText(
                                                            d.status
                                                        )}
                                                    </span>
                                                </td>
                                                <td className="px-4 py-4 whitespace-nowrap text-sm font-medium">
                                                    <button
                                                        onClick={() =>
                                                            handlerView(d.id)
                                                        }
                                                        className="text-indigo-600 hover:text-indigo-900 mr-2"
                                                    >
                                                        مشاهده
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default Dashboard
